import { render } from "./UpgradeRoom.vue?vue&type=template&id=3182089c&scoped=true"
const script = {}

import "./UpgradeRoom.vue?vue&type=style&index=0&id=3182089c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3182089c"]])

export default __exports__